import { generatePath, Link, RouteObject, useNavigate, useParams } from "react-router-dom";
import { ValidatedRoutes } from "../../components/PermissionedRoutes";
import React from "react";
import { v4 as uuidv4 } from "uuid";
import { useUserConfiguration } from "@hooks/useUserConfiguration";
import { TopBar } from "@components/TopBar";
import { Button } from "@narmi/design_system";
import { PageContainer } from "@components/PageContainer";

export const AUDIENCES_ROUTES: RouteObject[] = [
  {
    element: <ValidatedRoutes validate={({ features }) => features.includes("audiences")} />,
    children: [
      {
        index: true,
        async lazy() {
          const { AudiencesList } = await import("./AudiencesList");
          return {
            Component() {
              const createUuid = React.useMemo(() => uuidv4(), []);
              const { permissions } = useUserConfiguration();

              return (
                <>
                  <TopBar
                    title="Audiences"
                    action={
                      permissions.includes("indigo.add_audience") ? (
                        <>
                          <Link
                            to={{
                              pathname: generatePath("/audiences/:type/:audienceId/", {
                                type: "upload",
                                audienceId: createUuid,
                              }),
                            }}
                          >
                            <Button size="xs" label="Upload audience" kind="secondary" />
                          </Link>
                          <Link
                            to={{
                              pathname: generatePath("/audiences/:type/:audienceId/", {
                                type: "custom",
                                audienceId: createUuid,
                              }),
                            }}
                          >
                            <Button size="xs" label="New audience" />
                          </Link>
                        </>
                      ) : null
                    }
                  />
                  <PageContainer>
                    <AudiencesList />
                  </PageContainer>
                </>
              );
            },
          };
        },
      },
      {
        path: ":type/:audienceId/:section?",
        async lazy() {
          const { CreateForm } = await import("./CreateForm");

          return {
            Component() {
              const params = useParams<{
                type: "upload" | "custom";
                audienceId: string;
                section?: string;
              }>();
              const navigate = useNavigate();

              return (
                <>
                  <TopBar
                    title={params.type === "upload" ? "Upload audience" : "New audience"}
                    backIconOnClick={() => navigate("/audiences")}
                  />
                  <PageContainer>
                    <CreateForm
                      type={params.type!}
                      audienceId={params.audienceId!}
                      section={params.section ?? null}
                    />
                  </PageContainer>
                </>
              );
            },
          };
        },
      },
    ],
  },
];
